import { useCarConfigSelector } from "../../redux/store";
import type { AtmosphereType } from "../../utils/types/AtmosphereType";
import { useAphLbxAtmospheres } from "./useAphLbxAtmospheres";

export const useAphLbxCheapestAtmosphere = (): AtmosphereType => {
    const atmospheres = useAphLbxAtmospheres();
    const financeState = useCarConfigSelector((state) => state.carConfigAtmosphere.finance.state);
    const financeOption = useCarConfigSelector((state) => state.utils.financeOption);
    if (financeOption === "cash" || financeState !== "complete") {
        return [...atmospheres].sort((a, b) => a.price.cash - b.price.cash)[0];
    } else {
        return [...atmospheres]
            .filter(({ price }) => price.monthly > 0)
            .sort((a, b) => a.price.monthly - b.price.monthly)[0];
    }
};
